import { cloneDeep } from 'lodash';
const FIRE_UPGRADE_STATUS = 'FIRE_UPGRADE_STATUS';
const CLEAR_UPGRADE_STATUS = 'CLEAR_UPGRADE_STATUS';

const upgradeStatusInitialState = null;

export default function reducer(state = cloneDeep(upgradeStatusInitialState), action) {
	switch (action.type) {
		case FIRE_UPGRADE_STATUS:
			return true;
		case CLEAR_UPGRADE_STATUS:
			return null;
		default:
			return state;
	}
}

export function fireUpgradeStatus(){
	return { type: FIRE_UPGRADE_STATUS }
};

export function clearUpgradeStatus(){
	return { type: CLEAR_UPGRADE_STATUS }
}



// WEBPACK FOOTER //
// ./src/modules/upgrade_status.js